import ReactDOM from 'react-dom';
import React from 'react';
import { App } from './App';
import { StoreProvider } from './store/AppStore';
export const render = () => {
    const rootEl = document.getElementById('multishade-dialog-root');
    if (rootEl) {
        ReactDOM.render(React.createElement(StoreProvider, null,
            React.createElement(App, null)), rootEl);
    }
};
